module.exports = __webpack_public_path__ + "b0d2220cb75f72df147c18e7f4721e99.woff";